module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero11.png?105bcc30";